import {cursorTarget, setCursor, toFixedVector} from "../../utils/utils";
import * as Globals from "../../globals";
import {setActiveMode} from "../../globals";
import {buildingGroup, clearStates, tmpGroup, toggleModeButtons} from "../../main";
import {generateMeasurements} from "../measurements/measurementGeneration";
import {recalculateBuildingParameters} from "../../calculators/buildingParameters/parameterCalculator";
import {clearGroup} from "../../sceneManager";
import {PillarPreview} from "./pillarPreview";
import {Pillar} from "./pillar";
import {TransactionManager} from "../../TransactionManager";
import {updateWallSnapAxis} from "../walls/wallGeneration";
import {findChildrenByName} from "../../utils/threeUtils";
import {supportBeamMeshName} from "../../constants/nameConstants";
import {Box3} from "three";
import {showMessage} from "../../../ui/ui";
import {t} from "../../../i18n";

let currentPreview = null;
let currentEdit = null;

export function startPillarPreview(size, height) {
    currentPreview = new PillarPreview(size, size, height);
    setCursor(Globals.cursors.crosshair, cursorTarget.layoutView);
}

export function adjustPillarPreview() {
    if (currentPreview === null) {
        console.error("Currently no pillar preview exists");
        return;
    }

    currentPreview.adjustPreview();
}

export function pillarClick() {
    if (currentPreview === null) {
        console.error("Currently no pillar preview exists");
        return;
    }
    TransactionManager.startTransaction();
    let pillar = new Pillar(currentPreview).create();
    //currentPreview = null;
    //currentEdit = null;
    //clearStates();
    generateMeasurements().then();
    recalculateBuildingParameters().then();
    //toggleModeButtons();
    updateWallSnapAxis();
    TransactionManager.stopTransaction();
}

export function changePillar(pillar, size) {
    TransactionManager.startTransaction();
    setActiveMode(Globals.modes.pillar, $(this));
    currentEdit = pillar;
    pillar.removeFromParent();
    startPillarPreview(size, pillar.userData.height);
}

export function removeSupportedSupportBeams(pillar) {
    let allSupportBeams = findChildrenByName(buildingGroup, supportBeamMeshName);
    let pillarBounds = new Box3().setFromObject(pillar);

    let elementsDeleted = false;
    for (let i = 0; i < allSupportBeams.length; i++) {
        //Get intersecting pillars
        let boundsCopy = new Box3().setFromObject(allSupportBeams[i]);
        boundsCopy.min.y = 0;
        boundsCopy.max.y = 1;
        boundsCopy.min = toFixedVector(boundsCopy.min);
        boundsCopy.max = toFixedVector(boundsCopy.max);
        pillarBounds.min.y = 0;
        pillarBounds.max.y = 1;
        pillarBounds.min = toFixedVector(pillarBounds.min);
        pillarBounds.max = toFixedVector(pillarBounds.max);
        if (boundsCopy.containsBox(pillarBounds)) {
            elementsDeleted = true;
            clearGroup(allSupportBeams[i]);
            allSupportBeams[i].removeFromParent();
        }
    }

    if (elementsDeleted) {
        showMessage(t("pillar_removed_beam"));
    }
}

export function deletePillar(pillar) {
    clearGroup(pillar);
    pillar.removeFromParent();
    //TODO: Unterzug Spannweitenprüfung ggf?
}

export function clearPillarPreviewState() {
    if (currentEdit !== null) {
        buildingGroup.addWithUuid(currentEdit);
        if (currentPreview !== null) {
            clearGroup(currentPreview.previewMesh);
            currentPreview.previewMesh.removeFromParent();
        }
    }
    clearGroup(tmpGroup);
    currentPreview = null;
    currentEdit = null;
}
